import { createFileRoute } from "@tanstack/react-router";

import ExpressCheckoutContainer from "./-components/ExpressCheckoutContainer";
import WithGoogleAuth from "@/components/WithGoogleAuth";
import { GoogleAuthProvider } from "@/providers/GoogleAuthProvider";

export const Route = createFileRoute("/_app/express-checkout")({
  component: ExpressCheckout,
});

/**
 * Not a child of `_dashboard`: express checkout signs the buyer up as it goes,
 * so it needs the sign-up Google context and none of the dashboard chrome.
 */
function ExpressCheckout() {
  return (
    <WithGoogleAuth>
      <GoogleAuthProvider endpoint="register">
        <ExpressCheckoutContainer />
      </GoogleAuthProvider>
    </WithGoogleAuth>
  );
}
